import Control from "ol/control/Control";
import { Coordinate } from "ol/coordinate";
import { Pixel } from "ol/pixel";
import Vue, { Component } from 'vue'
import ContextMenu from "./ContextMenu.vue";

export default class ContextMenuControl extends Control {
    element: HTMLElement
    coordinate: Coordinate|undefined
    contextMenu: Vue
    constructor() {
        // https://css-tricks.com/creating-vue-js-component-instances-programmatically/
        const ComponentClass = Vue.extend(ContextMenu)
        const component = new ComponentClass()
        component.$mount()
        const element = component.$el as HTMLElement
        element.style.position = 'absolute'
        super({ element: element });
        this.contextMenu = component
        this.coordinate = undefined
        this.element = element
    }
    show(pixel: Pixel, coordinate: Coordinate) {
        this.element.style.left = pixel[0] + 'px'
        this.element.style.top = pixel[1] + 'px'
        this.coordinate = coordinate
        this.contextMenu.$data['TheDataMessage'] = 'Hello from show!'
        setTimeout(() => {
            this.element.style.display = 'block'
        })
    }
    hide() {
        this.element.style.display = 'none'
    }
}
